export class CipherMateConfig {
    url: string;
    token: string;
    fileIdFieldName = "CipherMate_FileID";
    useInstalled = false;
}
